<template>
  <div class="n-radio">
    <input
      type="radio"
      :name="name"
      :id="id"
      v-model="radio"
      :class="{ 'is-checked': radio == value }"
      :value="value"
      :disabled="disabled"
      @click="update"
    />
    <label :for="id">{{ label }}</label>
  </div>
</template>
<script>
export default {
  props: {
    id: {
      type: String,
      default: "",
    },
    config: {
      type: [String, Number, Boolean],
      default: false,
    },
    label: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    value: {
      type: [String, Number, Boolean],
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    config: {
      handler() {
        this.radio = this.config;
      },
      immediate: true,
    },
  },
  data() {
    return {
      radio: "",
    };
  },
  methods: {
    update() {
      this.$emit("update:config", this.value);
      this.$emit("click");
    },
  },
};
</script>
<style lang="scss">
@import "~@/styles/variables.scss";
$checkedCircleTop: ($formLineHeight - $formLabelFontSize)/2 - 1;
.n-radio {
  position: relative;
  display: inline-block;
  cursor: pointer;
  text-align: left;
  input[type="radio"] {
    position: absolute;
    opacity: 0;
    pointer-events: none;
  }
  input[type="radio"] + label {
    padding-left: $formLabelFontSize + 10;
    display: inline-block;
  }
  input[type="radio"]:disabled + label {
    color: $formGrayOutFontColor;
    cursor: not-allowed;
  }
  input[type="radio"] + label::before {
    content: " ";
    width: $formLabelFontSize;
    height: $formLabelFontSize;
    border: solid 1px $formBorderColor;
    background: #fff;
    border-radius: $formLabelFontSize;
    position: absolute;
    left: 0;
    top: ($formLineHeight - $formLabelFontSize)/2 - 2;
  }
  input[type="radio"]:hover + label::before {
    border: solid 1px $formCheckBoxColor;
  }
  input[type="radio"]:checked + label::before {
    content: " ";
    border: solid 1px $formCheckBoxColor;
    background: $formCheckBoxColor;
  }
  input[type="radio"]:checked + label::after,
  input[type="radio"]:checked + label::after {
    width: 8px;
    height: 8px;
    border-radius: 8px;
    background-color: $formCheckBoxColor;
    border: solid ($formLabelFontSize/2 - 4) #fff; // 3px
    content: "";
    position: absolute;
    left: 1px;
    top: $checkedCircleTop; // 12px
    border-radius: 9px;
  }
  input[type="radio"]:checked:disabled + label::before,
  input[type="radio"]:disabled + label::before {
    border-color: $formGrayOutColor;
  }
  input[type="radio"]:checked:disabled + label::after,
  input[type="radio"]:disabled + label::after {
    background-color: $formGrayOutColor;
    background: $formGrayOutColor;
  }
}
.n-radio.no-label-radio {
  input[type="radio"] + label::before {
    top: $formLabelFontSize/2 - 2; // 5px;
    left: $formLabelFontSize/2 - 2; // 5px;
  }
  input[type="radio"]:checked + label::after {
    top: $formLabelFontSize/2 - 1; // 6px;
    left: $formLabelFontSize/2 - 1; // 6px;
  }
}
.card-radio-list .n-radio {
  margin-bottom: 8px;
  input[type="radio"] + label::before {
    top: 3px;
    left: 0;
  }
  input[type="radio"]:checked + label::after {
    top: 4px;
    left: 1px;
  }
}
.smb-gui {
  .card input[type="radio"] + label {
    font-family: "Roboto-Regular";
  }
  .card-radio-list .n-radio {
    input[type="radio"] + label::before {
      top: 0;
    }
    input[type="radio"]:checked + label::after {
      top: 1px;
    }
  }
}
.form-oneline .radio-group {
  width: auto;
}
</style>
